import { render, staticRenderFns } from "./ForgottenPassword.vue?vue&type=template&id=57a514f8&scoped=true&"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js&"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgottenPassword.vue?vue&type=style&index=0&id=57a514f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a514f8",
  null
  
)

export default component.exports